import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import Button from '@prisjakt/ui-button';

export const Form = styled.form``;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  margin-bottom: ${layout.spacing.medium};
  margin-top: ${layout.spacing.medium};
  justify-content: flex-end;
  position: sticky;
  bottom: 0;
  border-top: 1px solid ${p => p.theme.lines.primary};
  padding: ${layout.spacing.xSmall} 0;
  background: ${p => p.theme.bg.primary};
  z-index: 10;
`;

export const SubmitButton = styled(Button)`
  width: 33%;

  ${media.mediumDown`
    width: 50%;
  `};
`;

export const CancelButton = styled(Button)`
  margin-right: ${layout.spacing.medium};
`;

export const DeleteButton = styled(Button)`
  margin-right: auto;
`;
